import { render, staticRenderFns } from "./word.vue?vue&type=template&id=6e84074f&scoped=true"
import script from "./word.vue?vue&type=script&lang=js"
export * from "./word.vue?vue&type=script&lang=js"
import style0 from "./word.vue?vue&type=style&index=0&id=6e84074f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e84074f",
  null
  
)

export default component.exports